
import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';


import Homepage from './pages/Homepage';
import Seo from './seo/Seo';
import Contactpage from './pages/Contactpage';
import Headshotpage from './pages/Headshotpage';
import Videopages from './pages/Videopages';
import Photographypage from './pages/Photographypage';
import Dronephotographypage from './pages/Dronephotographypage';
import Restaurantpage from './pages/Restaurantpage';
import Weddingpage from './pages/Weddingpage';


import Livestreampage from './pages/Livestreampage';

import Privacypage from './pages/Privacypage';
import Termspage from './pages/Termspage';


import Restaurantgallarypage from './pages/Restaurantgallarypage';
import Blogpage from './pages/Blogpage';

import Blogdetailspage from './pages/Blogdetailspage';
import Projectpage from './pages/Projectpage';
import Projectdetailspage from './pages/Projectdetailspage';




const ScrollToTop = () => {
  const { pathname } = useLocation();
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const App = () => {
  return (
    <>

      <ScrollToTop />
      <Seo />

      <Routes>
        <Route path='/' element={<Homepage />} />
        <Route path='/contact' element={<Contactpage />} />

        <Route path='/headshot' element={<Headshotpage />} />
        <Route path='/video' element={<Videopages />} />
        <Route path='/photography' element={<Photographypage />} />
        <Route path='/drone-photography' element={<Dronephotographypage />} />
        <Route path='/restaurant' element={<Restaurantpage />} />
        <Route path='/wedding-photography' element={<Weddingpage />} />

    
        <Route path='/live-stream' element={<Livestreampage />} />



        <Route path='/privacy-policy' element={<Privacypage />} />
        <Route path='/terms-conditions' element={<Termspage />} />
        <Route path='/moyer-blogs' element={<Blogpage />} />

        <Route path="/blog/:slug" element={<Blogdetailspage />} />

         <Route path="/moyer-projects" element={<Projectpage />} />
          <Route path="/projects/:id" element={<Projectdetailspage />} />

        <Route path="/:slug" element={<Restaurantgallarypage />} />






      </Routes>
    </>
  );
};

export default App;

